import {
  QuickResolveAction,
  QuickResolveActionItem,
} from '@hakimo-ui/hakimo/types';

export function isQuickResolveAction(
  item: QuickResolveActionItem
): item is QuickResolveAction {
  return typeof item === 'object' && item !== null && 'label' in item;
}

export function isQuickResolveActionString(
  item: QuickResolveActionItem
): item is string {
  return typeof item === 'string';
}

export function getQuickResolveActionLabel(
  item: QuickResolveActionItem
): string {
  return isQuickResolveAction(item) ? item.label : item;
}

export function hasQuickResolveSubActions(
  item: QuickResolveActionItem
): boolean {
  return (
    isQuickResolveAction(item) &&
    Boolean(item.subActions && item.subActions.length > 0)
  );
}
